<template>
<div class="site-builder">
	<div id="basic-blocks"></div>
	<div id="blocks"></div>
	<div id="gjs">
		<h1>Hello World Component!</h1>
	</div>
	<button class="save-button" @click="saveTemplate()">Save</button>
</div>
</template>

<script>
import grapesjs from 'grapesjs';
import pluginBlocks from 'grapesjs-blocks-basic'
import Chart from 'chart.js';
import { renderChart } from '@/utils/helpers.js'
import { mapActions, mapState } from 'vuex'

export default {
	data: () => ({
		editor: null
	}),
	mounted() {
		this.editor = grapesjs.init({
			container: '#gjs',
			fromElement: true,
			width: 'auto',
			plugins: [pluginBlocks],
			protectedCss: 'img{max-width:100%;}',
			storageManager: { type: '', autoload: 0 }
		})

		this.addImageCaptionBlock(this.editor.BlockManager)
		this.addImageGroupBlock(this.editor.BlockManager)
		this.addChartBlock()

		this.editor.on('block:drag:stop', component => {
			if (component && component.getAttributes()['data-image-caption']) {
				const imgComponent = component.find('img')[0]
				imgComponent && imgComponent.trigger('active')
			}
		})
		this.createColumnBlocks(this.editor)
		this.createCommonBlocks(this.editor)
		this.createChartBlocks(this.editor)
		this.editor.BlockManager.getCategories().models.map(ctg => ctg.set('open', false))
		this.editor.Commands.add('save-template', (editor, sender, opts = {}) => {
			editor.store()

			var htmldata = editor.getHtml()
			var cssdata = editor.getCss()

			opts.vm.setTemplate({
				name: 'name_' + Math.random().toString(36).substring(2, 15),
				sectorId: 1,
				regionId: 2,
				html: htmldata,
				css: cssdata,
				created_at: new Date().toISOString().slice(0, 10)
			}).then(() => {
				opts.vm.getTemplates()
			})
		})
	},
	created() {
		this.getOpportunity({
			opportunityId: 1
		})
	},
	computed: {
		...mapState({
			opportunity: ({ OpportunityStore }) => OpportunityStore.opportunity
		})
	},
	methods: {
		...mapActions({
			getTemplates: 'TemplateStore/getList',
			setTemplate: 'TemplateStore/setTemplate',
			getOpportunity: 'OpportunityStore/getOpportunity'
		}),
		createColumnBlocks(editor) {
			editor.BlockManager.get('column1').set('category', 'Column')
			editor.BlockManager.get('column2').set('category', 'Column')
			editor.BlockManager.get('column3').set('category', 'Column')
			editor.BlockManager.get('column3-7').set('category', 'Column')
			let blocks = editor.BlockManager.getAll()
			const filtered = blocks.filter(block => block.get('category') == 'Column')
			const newBlocksEl = editor.BlockManager.render(filtered, { external: true })
			document.getElementById('basic-blocks').appendChild(newBlocksEl)
		},
		createCommonBlocks(editor) {
			editor.BlockManager.get('text').set('category', 'Common')
			editor.BlockManager.get('image').set('category', 'Common')
			editor.BlockManager.get('map').set('category', 'Common')
			editor.BlockManager.get('link').set('category', 'Common')
			editor.BlockManager.get('image_caption').set('category', 'Common')
			editor.BlockManager.get('image_group').set('category', 'Common')
			let blocks = editor.BlockManager.getAll()
			const filtered = blocks.filter(block => block.get('category') == 'Common')
			const newBlocksEl = editor.BlockManager.render(filtered,{ external: true });
			document.getElementById('blocks').appendChild(newBlocksEl);
		},
		createChartBlocks(editor) {
			editor.BlockManager.get('chart').set('category', 'Chart')
			let blocks = editor.BlockManager.getAll()
			const filtered = blocks.filter(block => block.get('category') == 'Chart')
			const newBlocksEl = editor.BlockManager.render(filtered,{ external: true });
			document.getElementById('blocks').appendChild(newBlocksEl);
		},
		addImageCaptionBlock(blockManager) {
			blockManager.add('image_caption', {
				label: 'Image + caption',
				attributes: { class: 'gjs-fonts gjs-f-image' },
				content: `
					<div data-image-caption="1">
						<img src="" alt="image" />
						<p>Image caption</p>
					</div>
					<style>
						img {
							width: 100%;
						}
						p {
							text-align: center;
							font-size: 20px;
							margin: 5px 0px;
						}
					</style>
				`
			})
		},
		addImageGroupBlock(blockManager) {
			blockManager.add('image_group', {
				label: 'Image group',
				attributes: { class: 'fa fa-th'},
				content: `
					<div style="overflow-x:auto;">
						<table class="grid-item-row">
						<tr>
							<td class="grid-item-cell2-l">
								<img class="grid-item-image" style="width: 100%;" src="${require('../../../../../assets/images/logo_image.png')}" alt="Image"/>
							</td>
							<td class="grid-item-cell2-l">
								<img class="grid-item-image" style="width: 100%;" src="${require('../../../../../assets/images/logo_image.png')}" alt="Image"/>
							</td>
						</tr>
						<tr>
							<td class="grid-item-cell2-l">
								<img class="grid-item-image" style="width: 100%;" src="${require('../../../../../assets/images/logo_image.png')}" alt="Image"/>
							</td>
							<td class="grid-item-cell2-l">
								<img class="grid-item-image" style="width: 100%;" src="${require('../../../../../assets/images/logo_image.png')}" alt="Image"/>
							</td>
						</tr>
						</table>
					</div>
					<style>
						grid-item-row {
							width: 100%;
						}
					</style>
				`
			})
		},
		saveTemplate() {
			this.editor.Commands.run('save-template', { vm: this })
		},
		addChartBlock() {
			this.editor.DomComponents.getWrapper().find('.myChart').map((element) => {
				var element = element.view.el
				renderChart(element, this.opportunity.chart_data)
			})
			this.editor.on('component:add', model => {
				if(model.attributes.tagName == 'canvas') {
					var element = model.view.el
					renderChart(element, this.opportunity.chart_data)
				}
			});

			this.editor.BlockManager.add('chart', {
				 label: `
				 	<div>
						<img class="chart-image" src="` + require('@/assets/images/chart.svg') + `"/>
						<div class="my-label-block">Label block</div>
					</div>
					<style>
						.chart-image{width: 65%;margin-bottom: 10px;}
					</style>
				`,
				content: '<canvas style="width: 100% !important;height: auto !important;" class="myChart"></canvas>'
			});
		}
	}
}
</script>

<style lang="scss">
.site-builder {
	.save-button {
		color: #fff;
		position: absolute;
		bottom: 1%;
		z-index: 1;
		left: 60%;
		background: #4ba98b;
		font-size: 16px;
		text-transform: uppercase;
		border: none;
		padding: 10px 20px;
		border-radius: 10px;
		cursor: pointer;
		outline: none;
	}
	#blocks {
		position: absolute;
		top: 61px;
		right: 0;
		bottom: 0;
		width: 100px;
		z-index: 2;
		overflow-y: scroll;

		.gjs-title {
			padding: 5px;
			font-size: 14px;
			font-weight: 500;
		}
		.gjs-block {
			width: 100%;
		}
		.gjs-block-category {
			display: block;
		}
	}
	#basic-blocks {
		position: absolute;
		top: 61px;
		right: 0;
		left: 270px;
		bottom: 0;
		width: 100px;
		z-index: 2;
		overflow-y: scroll;

		.gjs-title {
			padding: 5px;
			font-size: 14px;
			font-weight: 500;
		}
		.gjs-block {
			width: 100%;
		}
		.gjs-block-category {
			display: block;
		}
		.gjs-blocks-cs {
			height: 100%;
		}
	}
	#gjs {
		position: absolute;
		top: 61px;
		right: 0;
		left: 370px;
		bottom: 0;
		height: auto !important;

		.gjs-cv-canvas {
			right: 100px;
			width: auto;
			height: 100%;
			top: 0;

			.gjs-frame {
				border: 10px solid #fff;
			}
		}
		.gjs-pn-panels {
			display: none;
		}
	}
	.gjs-block-category {
		&:not(:nth-child(1)) {
			display: none;
		}
	}
}
</style>
